<template>
  <div class="custom-modal" id="about" @click="clickOutside">
    <!-- Modal content -->
    <div class="modal-content">
      <h1>關於</h1>
      <span class="close" @click="modalClose('aboutModal')">&times;</span>
      <div class="content">
        <div class="box">
          <iframe src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Fsoulmatch2018%2F&width=450&layout=standard&action=like&size=small&show_faces=true&share=false&height=80&appId" width="100%" height="80" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
          <h2>為什麼是5分鐘呢？</h2>
          <blockquote style="padding:5px;margin:5px;">"So think of this as time travel...from then to now to find out what you're missing out on."</blockquote>

          <h2>作者是誰？</h2>
          <ul>
            <li>我是@realdennis 這是我興趣使然開發出來的程式...</li>
            <li>因為獨立開發，有什麼Bug請多包涵。</li>
            <li>若你對於這個網頁有什麼想法，歡迎透過
              <a class="social-media" href="https://www.facebook.com/soulmatch2018/" target="_blank">粉專</a>
              聯絡我。</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: 'aboutModal',
  methods: {
    ...mapMutations('modal', ['modalClose']),
    clickOutside(e) {
      if (e.target === document.querySelector('div.custom-modal')) {
        this.modalClose('aboutModal');
      }
    }
  }
};
</script>
<style scoped lang="scss">
#about {
  .modal-content {
    max-width: 350px;
  }
  .social-media {
    text-decoration: none;
    color: #f96f87;
  }
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
